import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, bindActionCreators } from 'redux';

import {
  selectActualDevices,
  selectContentProvider,
  selectCustomerId,
  selectExpirationDevices,
  selectLimitDevices,
  selectReturnUrl,
  selectCancelUrl,
} from '../../global-selectors';
import { selectDevices } from '../../queries/selectors/devices';
import { getDevices, deleteDevice } from '../../queries/affiliates';
import { mutateAsync } from '../../queries/actions';
import DevicesLimit from '../../components/DevicesLimit';
import { connectRequest } from '../../utils/query';

const mapStateToProps = (state) => {
  const cp = selectContentProvider(state);
  const customerId = selectCustomerId(state);
  const return_url = selectReturnUrl(state);
  const cancel_url = selectCancelUrl(state);
  return {
    cp,
    customerId,
    return_url,
    cancel_url,
    devices: selectDevices(state),
    limit: selectLimitDevices(state),
    actual: selectActualDevices(state),
    expiration: selectExpirationDevices(state),
    redirectToCancel: () => (window.location.href = cancel_url),
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  deleteDevice: (payload) => mutateAsync(deleteDevice, payload),
  deleteAllDevices: (payload) => mutateAsync(deleteDevice, payload),
}, dispatch);

const mapPropsToConfig = (props) => {
  // Validar que los parámetros requeridos estén presentes
  if (!props.cp || !props.customerId) {
    console.warn('[DevicesLimit] Faltan parámetros requeridos:', {
      cp: props.cp,
      customerId: props.customerId,
      limit: props.limit,
      actual: props.actual,
      expiration: props.expiration,
      return_url: props.return_url,
      cancel_url: props.cancel_url,
    });
    return []; // Retornar array vacío si faltan parámetros críticos
  }
  return [getDevices(props)];
};

export default compose(injectIntl, connect(mapStateToProps, mapDispatchToProps), connectRequest(mapPropsToConfig))(DevicesLimit);
